export const decodeAnalyticsDisplayValue = (value) => {
  if (typeof value !== 'string') return '';

  let decoded = value.trim();
  if (!decoded) return '';

  for (let attempt = 0; attempt < 3; attempt += 1) {
    if (!/%[0-9A-Fa-f]{2}/.test(decoded)) {
      break;
    }

    try {
      const nextValue = decodeURIComponent(decoded);
      if (nextValue === decoded) {
        break;
      }
      decoded = nextValue;
    } catch {
      break;
    }
  }

  decoded = decoded.replace(/%20/gi, ' ').replace(/\s+/g, ' ').trim();
  if (!decoded || /^%+$/.test(decoded)) {
    return '';
  }

  return decoded;
};

export const displayAnalyticsValue = (value, fallback) => decodeAnalyticsDisplayValue(value) || fallback;

export const displayUtmValue = (value, fallback = '') => {
  const decoded = decodeAnalyticsDisplayValue(value);
  if (!decoded) {
    return fallback;
  }

  const normalized = decoded.toLowerCase();
  if (normalized === 'unknown' || normalized === 'direct') {
    return fallback;
  }

  return decoded;
};

export const hasMeaningfulUtmValue = (value) => Boolean(displayUtmValue(value, ''));

export const formatTimestamp = (value) => {
  const numericTs = Number(value);
  const parsedTs = Number.isFinite(numericTs) && numericTs > 0
    ? numericTs
    : Date.parse(value);

  if (!Number.isFinite(parsedTs) || parsedTs <= 0) return 'Unknown';
  return new Date(parsedTs).toLocaleString();
};

export const formatDuration = (value) => {
  const durationMs = Number(value);
  if (!Number.isFinite(durationMs) || durationMs <= 0) return '0s';

  const seconds = Math.floor(durationMs / 1000);
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (minutes < 60) {
    return `${minutes}m ${remainingSeconds}s`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}h ${remainingMinutes}m`;
};

export const shortId = (value) => {
  if (!value) return 'unknown';
  return value.length <= 12 ? value : `${value.slice(0, 8)}...`;
};

export const shortHash = (value) => {
  if (!value) return 'No hash';
  return value.length <= 12 ? value : `${value.slice(0, 10)}...`;
};
